export default "__VITE_ASSET__6d5d3af0__"